import { useState } from "react";
import clsx from "clsx";
import RoomItemChecker from "@/components/dev/RoomItemChecker/RoomItemChecker";
import { BalancingDashboard } from "@/components/dev/BalancingDashboard/BalancingDashboard";
import QuickPlayTool from "@/components/dev/QuickPlayTool/QuickPlayTool";

type Props = {
    className?: string;
    onClose?: () => void;
};

type AvailableTool = "room-item-checker" | "balance-checker" | "quick-play";

const DevTools = ({ className, onClose }: Props) => {
    const [selectedTool, setSelectedTool] = useState<AvailableTool | null>(null);
    return (
        <div className="size-full flex flex-col items-center">
            <header className="w-full bg-gray-900 text-white px-4 py-3 text-center">
                <h1 className="text-lg font-bold tracking-wide">Dev-Tools</h1>
            </header>

            {!selectedTool && (
                <div className="w-full max-w-md px-4 py-6 space-y-3">
                    <button
                        className="block w-full rounded bg-purple-500 px-4 py-3 text-white text-left hover:bg-purple-600 cursor-pointer"
                        onClick={() => setSelectedTool("quick-play")}
                    >
                        Quick Play
                    </button>
                    <button
                        className="block w-full rounded bg-blue-500 px-4 py-3 text-white text-left hover:bg-blue-600 cursor-pointer"
                        onClick={() => setSelectedTool("room-item-checker")}
                    >
                        Room Item Checker
                        <span className="ml-2 text-xs opacity-70">(desktop only)</span>
                    </button>
                    <button
                        className="block w-full rounded bg-green-500 px-4 py-3 text-white text-left hover:bg-green-600 cursor-pointer"
                        onClick={() => setSelectedTool("balance-checker")}
                    >
                        Balance Checker
                        <span className="ml-2 text-xs opacity-70">(desktop only)</span>
                    </button>
                </div>
            )}
            {selectedTool === "room-item-checker" && <RoomItemChecker />}
            {selectedTool === "balance-checker" && <BalancingDashboard />}
            {selectedTool === "quick-play" && <QuickPlayTool onClose={onClose} />}
        </div>
    );
};

export default DevTools;